import React from "react";
// eslint-disable-next-line import/extensions
import ApiManager from "../../../Api/ApiManager";

export interface ApiContextProps {
  apiManager?: ApiManager;
}

export const ApiContext = React.createContext<ApiContextProps>({
  apiManager: new ApiManager(),
});

export interface ApiProviderProps {
  ApiManagerClass: typeof ApiManager;
}

export interface ApiProviderState {
  apiManagerInstance: ApiManager;
}

export default class ApiProvider extends React.Component<ApiProviderProps, ApiProviderState> {
  constructor(props: ApiProviderProps) {
    super(props);
    const { ApiManagerClass } = props;
    this.state = {
      apiManagerInstance: new ApiManagerClass(),
    };
  }

  render() {
    const { children } = this.props;
    const { apiManagerInstance } = this.state;
    return (
      <ApiContext.Provider value={{
        apiManager: apiManagerInstance,
      }}
      >
        {children}
      </ApiContext.Provider>
    );
  }
}

export const ApiConsumer = ApiContext.Consumer;

export const withApi = (WrappedComponent: any) => {
  return class extends React.Component<any, any> {
    render() {
      return (
        <ApiConsumer>
          {({ apiManager }) => (
            <WrappedComponent
              {...this.props}
              apiManager={apiManager}
            />
          )}
        </ApiConsumer>
      );
    }
  };
};
